/* eslint-disable react/prop-types */
import { FC } from 'react';
import { Logo } from 'cosmos-components';
import styled from 'styled-components';

import heroBanner from 'src/assets/images/hero-banner-new.jpg';
import { useWindowDimensions } from 'src/hooks/useWindowDimensions';

import {
    ApolloLogo,
    StyledHeader,
    StyledHeroBanner,
    StyledDivider,
    HeaderIconContainer,
} from './Header';
import { HeaderIcons } from './EMHeader';
import { DeviceType } from 'src/enums';

export const UKHeader: FC = () => {
    const { deviceType } = useWindowDimensions();

    return (
        <StyledHeader>
            <HeaderIcons id="header-icons" deviceType={deviceType}>
                <HeaderIconContainer>
                    <ApolloLogo name="coloredApollo" deviceType={deviceType} />
                </HeaderIconContainer>
                <HeaderIconContainer>
                    <ColoredBunkLogo name="coloredBunk" deviceType={deviceType} />
                </HeaderIconContainer>
                <HeaderIconContainer>
                    <ColoredJustGoLogo name="coloredJustGo" deviceType={deviceType} />
                </HeaderIconContainer>
            </HeaderIcons>
            <StyledHeroBanner src={heroBanner} />
            <StyledDivider />
        </StyledHeader>
    );
};

export const ColoredBunkLogo = styled(Logo)<{ deviceType: DeviceType }>`
    width: ${({ deviceType }) =>
        deviceType === DeviceType.Mobile ? '4rem' : '7rem'};
    padding-right: ${({ deviceType }) =>
        deviceType === DeviceType.Mobile ? '1.16rem' : '2.16rem'};
    vertical-align: ${({ deviceType }) =>
        deviceType === DeviceType.Mobile ? '-1rem' : '-3rem'};
`;

export const ColoredJustGoLogo = styled(Logo)<{ deviceType: DeviceType }>`
    width: ${({ deviceType }) =>
        deviceType === DeviceType.Mobile ? '4rem' : '6.5rem'};
    padding-right: ${({ deviceType }) =>
        deviceType === DeviceType.Mobile ? '1.16rem' : '2.16rem'};
    vertical-align: ${({ deviceType }) =>
        deviceType === DeviceType.Mobile ? '-1rem' : '-3rem'};
`;
